/* eslint-disable max-len */
const compose = (...fns) => (...args) => fns.reduceRight((res, fn) => [fn.call(null, ...res)], args)[0];

function removeItemFromArrayByIndex(index, arr) {
	return arr.reduce((list, item, ind) => {
		const newList = [...list];
		if (index === ind) {
			return newList;
		}
		return newList.concat(item);
	}, []);
}

function setNewProperty(property, value) {
	return function p(obj) {
		const newObj = { ...obj };
		newObj[property] = value;
		return newObj;
	};
}

function getPropertysValue(val) {
	return function inner(obj) {
		if (typeof obj[val] === 'object') {
			return obj[val];
		}
		return obj;
	};
}

function buildObject(...keys) {
	let newObj = {};
	return function inner(...arg) {
		keys.forEach((key, index) => {
			newObj = setNewProperty(key, arg[index])(newObj);
		});
		return newObj;
	};
}

function map(fn, col) {
	return col.map(fn);
}

export default {
	buildObject,
	compose,
	getPropertysValue,
	map,
	removeItemFromArrayByIndex,
	setNewProperty,
};



// WEBPACK FOOTER //
// ./src/shared/lib.js